<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Courses'"></span>
          <v-btn
            v-if="
              roleName == 'SUPER ADMIN' ||
              roleName == 'ADMIN' ||
              roleName == 'MANAGER' ||
              roleName == 'TEACHER'
            "
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            to="/course/create"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            :to="`/course/upload`"
          >
            <v-icon dark> mdi-upload </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-row v-if="roleName != 'CANDIDATE'">
                <v-col md="6">
                  <v-text-field
                    v-model="search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    @keydown.enter="getData"
                    @change="page = 1"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="created_by"
                    v-model="created_by_id"
                    :items="created_by"
                    label="Created By"
                    @change="(page = 1), getData()"
                    prepend-icon="mdi-account"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="subject_filter"
                    v-model="subject_id"
                    :items="Subjects"
                    label="Subject"
                    @change="(page = 1), getData()"
                    prepend-icon="mdi-book"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="4" v-if="roleName == 'CANDIDATE'">
                  <v-text-field
                    v-model="search_keyword"
                    label="Search courses"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    v-model="is_active"
                    v-if="roleName !== 'CANDIDATE'"
                    :items="statuses"
                    label="Status"
                    @change="(page = 1), getData()"
                    prepend-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    ref="status"
                    v-model="course_status"
                    v-else
                    :items="candidate_status"
                    label="Status"
                    @change="(page = 1), applyCandidateView()"
                    prepend-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>

                <v-col md="4">
                  <v-pagination
                    v-model="page"
                    circle
                    :length="paginationLength"
                    :total-visible="7"
                  >
                  </v-pagination>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Course Name</th>
                    <th class="text-left">Subject</th>
                    <th class="text-left">Passing Marks</th>
                    <th class="text-left">Attempts</th>
                    <th v-if="roleName == 'CANDIDATE'" class="text-left">
                      Video Count
                    </th>
                    <th v-if="roleName == 'CANDIDATE'" class="text-left">
                      Document Count
                    </th>
                    <th v-if="roleName == 'CANDIDATE'" class="text-left">
                      Description Count
                    </th>
                    <th v-if="roleName == 'CANDIDATE'" class="text-left">
                      Attempts Done
                    </th>
                    <th class="text-left">Exam Duration</th>
                    <th
                      class="text-center"
                      v-if="(roleName == 'SUPER ADMIN' || roleName == 'ADMIN' || roleName == 'MANAGER') && !isDesktop"
                    >
                      Pre-Join
                    </th>
                    <th
                      style="width: 18%"
                      class="text-center"
                      v-if="
                        roleName == 'SUPER ADMIN' ||
                        roleName == 'ADMIN' ||
                        roleName == 'MANAGER' ||
                        roleName == 'TEACHER'
                      "
                    >
                      Action
                    </th>
                    <th style="width: 14%" class="text-center" v-else>View</th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    (courses.length != 0 && roleName == 'SUPER ADMIN') ||
                    roleName == 'ADMIN' ||
                    roleName == 'MANAGER' ||
                    roleName == 'TEACHER' ||
                    roleName == 'COMPANY'
                  "
                >
                  <tr v-for="(course, i) in courses" :key="`course${i}`">
                    <td style="min-width: 85px">
                      <!-- Offline course indicators -->
                      <v-tooltip
                        bottom
                        v-if="
                          course.is_offline && course.sync_status === 'pending'
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="orange"
                          >
                            mdi-wifi-off
                          </v-icon>
                        </template>
                        <span>Offline - Pending Sync</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-else-if="
                          course.is_offline && course.sync_status === 'synced'
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="secondary"
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                        <span>Synced Successfully</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-else-if="
                          course.is_offline && course.sync_status === 'failed'
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>Sync Failed</span>
                      </v-tooltip>

                      <!-- Regular online course indicators -->
                      <v-tooltip bottom v-else-if="course.is_active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>course is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else-if="course.is_active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>course is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td class="text-left">{{ course.name || "" }}</td>
                    <td class="text-left">
                      {{ course.subject ? course.subject.description : "" }}
                    </td>
                    <td class="text-left">
                      {{ course.passing_marks ? course.passing_marks : "" }}
                    </td>
                    <td class="text-left">
                      {{ course.no_of_attempt ? course.no_of_attempt : "" }}
                    </td>
                    <td class="text-left">
                      {{ course.exam_duration ? course.exam_duration : "" }}
                    </td>
                    <td
                      class="text-center"
                      v-if="(roleName == 'SUPER ADMIN' || roleName == 'ADMIN' || roleName == 'MANAGER') && !isDesktop"
                    >
                      <v-checkbox
                        v-model="course.is_pre_join"
                        hide-details
                        dense
                        class="mt-0 pt-0"
                        @change="togglePreJoin(course)"
                      ></v-checkbox>
                    </td>
                    <td
                      v-if="
                        roleName == 'SUPER ADMIN' ||
                        roleName == 'ADMIN' ||
                        roleName == 'MANAGER' ||
                        roleName == 'TEACHER' ||
                        roleName == 'COMPANY'
                      "
                    >
                      <div
                        v-if="
                          roleName == 'SUPER ADMIN' ||
                          roleName == 'ADMIN' ||
                          roleName == 'MANAGER' ||
                          roleName == 'TEACHER'
                        "
                        style="display: flex; justify-content: center"
                      >
                        <v-btn
                          class="mx-2"
                          fab
                          x-small
                          color="primary"
                          :to="`/course/${course.id}`"
                        >
                          <v-icon dark> mdi-pencil </v-icon>
                        </v-btn>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="mr-1"
                              color="black"
                              x-small
                              dark
                              fab
                              v-bind="attrs"
                              v-on="on"
                              :to="{
                                path: `/question/course/${course.id}`,
                                query: { course_name: course.name },
                              }"
                            >
                              <v-icon dark>mdi-folder-question</v-icon>
                            </v-btn>
                          </template>
                          <span>Questions</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="warning"
                              x-small
                              fab
                              dark
                              v-bind="attrs"
                              v-on="on"
                              :to="{
                                path: `/course/candidates/${course.id}`,
                                query: { course_name: course.name },
                              }"
                            >
                              <v-icon>mdi-account-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Candidates</span>
                        </v-tooltip>
                        <!-- <v-btn class="mx-2" fab x-small color="error" @click="Delete_this(course.id)">
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn> -->
                      </div>
                      <div
                        v-if="roleName == 'COMPANY'"
                        style="display: flex; justify-content: center"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="warning"
                              x-small
                              fab
                              dark
                              v-bind="attrs"
                              v-on="on"
                              :to="{
                                path: `/course/candidates/${course.id}`,
                                query: { course_name: course.name },
                              }"
                            >
                              <v-icon>mdi-account-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Candidates</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="courses.length != 0 && roleName == 'CANDIDATE'"
                >
                  <tr v-for="(course, i) in form" :key="`course${i}`">
                    <td style="min-width: 85px">
                      <v-tooltip bottom v-if="course.is_active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>course is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="course.active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>course is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td class="text-left">
                      {{ course.course.name || "" }}
                      <v-tooltip bottom v-if="course.course && course.course.is_pre_join">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            x-small
                            color="purple"
                            dark
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon x-small left>mdi-account-clock</v-icon>
                            Pre-Join
                          </v-chip>
                        </template>
                        <span>Pre-Join Course - Available before joining vessel</span>
                      </v-tooltip>
                    </td>
                    <td class="text-left">
                      {{
                        course.course.subject
                          ? course.course.subject.description
                          : ""
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course.passing_marks
                          ? course.course.passing_marks
                          : ""
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course.no_of_attempt
                          ? course.course.no_of_attempt
                          : ""
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course_view_count
                          ? course.course_view_count.video_count
                          : ""
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course_view_count
                          ? course.course_view_count.document_count
                          : ""
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course_view_count
                          ? course.course_view_count.text_count
                          : ""
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course_exam
                          ? course.course_exam.attempt_no
                          : "0"
                      }}
                    </td>
                    <td class="text-left">
                      {{
                        course.course.exam_duration
                          ? course.course.exam_duration
                          : ""
                      }}
                    </td>
                    <td
                      class="text-right"
                      v-if="
                        roleName == 'CANDIDATE' &&
                        course.is_expired == false &&
                        course.is_completed == false
                      "
                    >
                      <v-btn
                        class="mx-2"
                        style="padding: 0 10px; font-size: 11px"
                        color="primary"
                        :to="`/course/candidate/${course.course.id}`"
                      >
                        View Course
                      </v-btn>
                    </td>
                    <td
                      class="text-left"
                      v-else-if="
                        roleName == 'CANDIDATE' && course.is_completed == true
                      "
                    >
                      <div style="display: flex; gap: 8px; align-items: center;">

                        <!-- Certificate Status & Actions -->
                        <div v-if="course.cert_no">
                          <!-- Certificate Ready - Show Download Button -->
                          <v-btn
                            color="success"
                            small
                            @click="downloadCertificate(course)"
                            :loading="certificateLoading[course.course.id]"
                            :disabled="certificateLoading[course.course.id]"
                          >
                            <v-icon left small>mdi-download</v-icon>
                            Download Certificate
                          </v-btn>
                        </div>

                        <div v-else>
                          <!-- Certificate Not Generated Yet - Show Generate Button -->
                          <v-btn
                            color="warning"
                            small
                            @click="generateCertificate(course)"
                            :loading="certificateLoading[course.course.id]"
                            :disabled="certificateLoading[course.course.id]"
                          >
                            <v-icon left small>mdi-plus-circle</v-icon>
                            Generate Certificate
                          </v-btn>
                        </div>

                        <!-- Course Completion Status -->
                        <v-chip color="success" small outlined>
                          <v-icon left small>mdi-check-circle</v-icon>
                          Completed
                        </v-chip>

                        <!-- Certificate Number Display -->
                        <v-tooltip bottom v-if="course.cert_no">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              small
                              color="primary"
                              outlined
                              v-bind="attrs"
                              v-on="on"
                            >
                              {{ course.cert_no.split('/').pop() }}
                            </v-chip>
                          </template>
                          <span>Certificate No: {{ course.cert_no }}</span>
                        </v-tooltip>

                      </div>
                    </td>
                    <td class="text-left" v-else>
                      <v-btn
                        class="mx-2"
                        style="padding: 0px 25px; font-size: 11px"
                        color="red"
                        @click="showExpiredDialog"
                      >
                        Expired
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="expiredDialog" max-width="400">
        <v-card>
          <v-card-title class="headline red--text">
            Course Expired
          </v-card-title>
          <v-card-text>
            This course has expired. Please contact admin for assistance.
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="expiredDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import { generateCertificatePDF, formatCertificateDate } from "@/services/certificatePdfService";

export default {
  name: "CoursesPage",
  data() {
    return {
      form: {
        roles: [],
      },
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      candidate_status: [
        {
          id: 0,
          text: "Select Course Status",
          value: "",
        },
        { id: "COMPLETED", text: "COMPLETED", value: "COMPLETED" },
        { id: "EXPIRED", text: "EXPIRED", value: "EXPIRED" },
      ],
      courses: [],
      candidateSource: [],
      Subjects: [],
      page: 1,
      rowsPerPage: 10,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      isLoading: false,
      is_expired: false,
      expiredDialog: false,
      created_by: [],
      created_by_id: "",
      subject_id: "",
      is_active: "",
      company_user_id: "",
      course_status: "",
      // Certificate management
      certificateLoading: {}, // Track loading state per course
      certificateDialog: false,
      certificateUrl: '',
      selectedCourse: null
    };
  },
  watch: {
    page() {
      if (this.roleName == "CANDIDATE") this.applyCandidateView();
      else this.getData();
    },
    search_keyword() {
      // Candidate search is client-side over the full list; reset to page 1 and re-filter.
      if (this.roleName == "CANDIDATE") {
        this.page = 1;
        this.applyCandidateView();
      }
    },
  },
  computed: {
    isDesktop() {
      return !!window.electron;
    },
  },
  mounted() {
    this.disableBackButton();
    if (this.roleName == "CANDIDATE") {
      this.candidate_id = this.user.id;
    }
    if (this.roleName == "COMPANY") {
      this.company_user_id = this.user.id;
    }
    this.getData();
    this.getMasters();
  },
  beforeDestroy() {
    // Re-enable the back button functionality when the component is destroyed
    this.enableBackButton();
  },
  methods: {
    async togglePreJoin(course) {
      try {
        await axios.post('/courses/bulk-pre-join', {
          course_ids: [course.id],
          is_pre_join: course.is_pre_join ? true : false
        });
        console.log(`Course ${course.id} pre-join status updated to ${course.is_pre_join}`);
      } catch (error) {
        console.error('Failed to update pre-join status:', error);
        // Revert the checkbox on error
        course.is_pre_join = !course.is_pre_join;
      }
    },
    showExpiredDialog() {
      this.expiredDialog = true;
    },

    async generateCertificate(course) {
      try {
        // Set loading state
        this.$set(this.certificateLoading, course.course.id, true);

        const response = await axios.post('/api/generate_certificate', {
          course_id: course.course.id,
          candidate_id: this.user.id
        });

        if (response.data.success) {
          // Update the course object with new cert_no
          const courseIndex = this.form.findIndex(c => c.course.id === course.course.id);
          if (courseIndex !== -1) {
            this.$set(this.form[courseIndex], 'cert_no', response.data.cert_no);
          }

          // Show success message
          this.$toast.success('Certificate generated successfully!');

          // Optionally auto-download
          if (response.data.cert_no) {
            setTimeout(() => this.downloadCertificate(course), 1000);
          }
        }
      } catch (error) {
        console.error('Certificate generation failed:', error);
        this.$toast.error(error.response?.data?.message || 'Certificate generation failed');
      } finally {
        this.$set(this.certificateLoading, course.course.id, false);
      }
    },

    async downloadCertificate(course) {
      if (!course.cert_no) {
        this.$toast.warning('Certificate not available');
        return;
      }

      try {
        this.$set(this.certificateLoading, course.course.id, true);

        // Build certificate data from course and user info
        const certificateData = {
          candidateName: `${this.user.name || ''} ${this.user.last_name || ''}`.trim(),
          cdcNumber: this.user.cdc || 'N/A',
          courseName: course.course?.name || course.name || '',
          completionDate: formatCertificateDate(course.created_at || course.updated_at),
          presentedDate: formatCertificateDate(course.created_at || course.updated_at),
          validityPeriod: course.course?.validity_period || '12 months',
          certNo: course.cert_no
        };

        // Generate PDF using frontend service
        await generateCertificatePDF(certificateData);

        this.$toast.success('Certificate downloaded successfully!');

      } catch (error) {
        console.error('Certificate download failed:', error);
        this.$toast.error('Certificate download failed');
      } finally {
        this.$set(this.certificateLoading, course.course.id, false);
      }
    },

    refreshCourseData() {
      // Refresh the course listing to get updated cert_no values
      this.getData();
    },
    async getMasters() {
      try {
        // Get value lists data (subjects)
        let valueListsResponse = await axios.get("value_lists/showAll");
        let rawData = valueListsResponse.data?.data || [];

        // Group data by category (value_id)
        let masters = {
          vessels: rawData.filter(item => item.value_id === 6),
          ranks: rawData.filter(item => item.value_id === 1),
          subjects: rawData.filter(item => item.value_id === 3),
          duration: rawData.filter(item => item.value_id === 2),
          nationality: rawData.filter(item => item.value_id === 4),
          birth_place: rawData.filter(item => item.value_id === 5),
        };

        // Get user data (created_by)
        let usersResponse = await axios.get("users/masters");
        let usersData = usersResponse.data?.data || {};

        console.log("Course listing: Value lists data received:", masters);
        console.log("Course listing: Users data received:", usersData);

        // Clear existing data
        this.Subjects = [];
        this.created_by = [];

        // Handle subjects data
        if (masters.subjects && Array.isArray(masters.subjects)) {
          masters.subjects.forEach((Subject) => {
            if (Subject && Subject.id && Subject.description) {
              this.Subjects.push({
                id: Subject.id,
                text: Subject.description,
                value: Subject.id,
              });
            }
          });
        }

        // Handle created_by data (users who can create courses)
        if (usersData.created_by && Array.isArray(usersData.created_by)) {
          usersData.created_by.forEach((created_by) => {
            if (created_by && created_by.id && created_by.name) {
              this.created_by.push({
                id: created_by.id,
                text: created_by.name,
                value: created_by.id,
              });
            }
          });
        }

        console.log(
          "Course listing: Masters data loaded - Subjects:",
          this.Subjects.length,
          "Created by:",
          this.created_by.length
        );
      } catch (error) {
        console.error("Course listing: Error loading masters data:", error);
        this.Subjects = [];
        this.created_by = [];
      }
    },
    async getData() {
      this.candidate_id = this.candidate_id ? this.candidate_id : "";
      this.is_active = this.is_active ? this.is_active : 1;
      this.created_by_id = this.created_by_id ? this.created_by_id : "";
      this.subject_id = this.subject_id ? this.subject_id : "";
      this.course_status = this.course_status ? this.course_status : "";
      this.company_user_id = this.company_user_id ? this.company_user_id : "";

      let query =
        "page=" +
        this.page +
        "&subject_id=" +
        this.subject_id +
        "&active=" +
        this.is_active +
        "&search_keyword=" +
        this.search_keyword +
        "&candidate_id=" +
        this.candidate_id +
        "&company_user_id=" +
        this.company_user_id +
        "&created_by_id=" +
        this.created_by_id +
        "&is_completed=" +
        (this.course_status === "COMPLETED" ? "1" : "") + // include is_completed based on selected status
        "&is_expired=" +
        (this.course_status === "EXPIRED" ? "1" : "") +
        "&rowsPerPage=" +
        this.rowsPerPage;

      this.isLoading = true;

      if (this.roleName == "CANDIDATE") {
        // Pre-join visibility logic:
        // Portal (web) + pre-join candidate = show ONLY pre-join courses
        // Desktop (Electron) = show ALL courses
        const isDesktop = !!window.electron;
        const isPreJoinCandidate = this.user && this.user.is_pre_join;
        let preJoinParams = '';
        if (!isDesktop && isPreJoinCandidate) {
          preJoinParams = '&is_portal=true&is_pre_join_candidate=true';
        }
        // Fetch the candidate's FULL (deduped) course list in one shot. Search, status
        // filtering and paging are all done client-side (see applyCandidateView) so the
        // search box matches across every course, not just the current page.
        const candidateQuery =
          `page=1&rowsPerPage=100000&candidate_id=${this.candidate_id}&active=${this.is_active}`;
        let courses = await axios.get(
          `/course_candidates?${candidateQuery}${preJoinParams}`
        );
        this.candidateSource = courses.data.data || [];
        this.isLoading = false;
        this.applyCandidateView();
        return;
      } else {
        let courses = await axios.get(`/course?${query}`);
        this.form = courses.data.data;
        this.courses = courses.data.data;
        this.count = courses.data.count;

        // If in offline mode, merge updated courses and add offline courses
        if (window.electron) {
          try {
            const { offlineCourseStorage } = await import(
              "@/services/offline-course-storage"
            );

            // First, get updated courses and merge them with existing data
            const updatedCourses =
              await offlineCourseStorage.getAllUpdatedCourses();
            if (updatedCourses.length > 0) {
              // Replace existing courses with updated versions
              this.courses = this.courses.map((course) => {
                const updatedCourse = updatedCourses.find(
                  (updated) =>
                    updated.original_id &&
                    updated.original_id.toString() === course.id.toString()
                );
                return updatedCourse || course;
              });
              console.log(
                "Offline mode: Merged",
                updatedCourses.length,
                "updated courses"
              );
            }

            // Then add purely offline-created courses
            const offlineCourses =
              await offlineCourseStorage.getAllOfflineCourses();
            const newOfflineCourses = offlineCourses.filter(
              (course) => !course.is_updated
            );

            // Add offline courses to the list with visual indicators
            const enrichedOfflineCourses = newOfflineCourses.map((course) => ({
              ...course,
              name: course.name + " (Offline)",
              is_offline: true,
              sync_status: course.sync_status || "pending",
            }));

            this.courses = [...this.courses, ...enrichedOfflineCourses];
            this.count += enrichedOfflineCourses.length;
          } catch (error) {
            console.error("Failed to load offline courses:", error);
          }
        }
      }

      this.isLoading = false;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
    },

    // Candidate view: filter the full fetched list by status + search keyword,
    // then paginate on the client. Keeps search working across all pages.
    applyCandidateView() {
      let list = this.candidateSource || [];

      // Status filter (matches the candidate_status dropdown).
      if (this.course_status === "COMPLETED") {
        list = list.filter((c) => c.is_completed == true);
      } else if (this.course_status === "EXPIRED") {
        list = list.filter((c) => c.is_expired == true);
      }

      // Search filter: course name or subject description.
      const kw = (this.search_keyword || "").trim().toLowerCase();
      if (kw) {
        list = list.filter((item) => {
          const name =
            item.course && item.course.name ? item.course.name.toLowerCase() : "";
          const subject =
            item.course && item.course.subject && item.course.subject.description
              ? item.course.subject.description.toLowerCase()
              : "";
          return name.includes(kw) || subject.includes(kw);
        });
      }

      // Show completed courses first, then not-completed (stable within each group).
      const isDone = (v) => (v === true || v === 1 || v === "1" ? 1 : 0);
      list = [...list].sort(
        (a, b) => isDone(b.is_completed) - isDone(a.is_completed)
      );

      this.count = list.length;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage) || 1;
      if (this.page > this.paginationLength) this.page = this.paginationLength;

      const start = (this.page - 1) * this.rowsPerPage;
      const pageItems = list.slice(start, start + this.rowsPerPage);

      this.form = pageItems;
      this.is_expired = pageItems.some((c) => c.is_expired == true);
      this.courses = pageItems.map((item) => ({
        ...item.course,
        total_no_of_attempts: item.total_no_of_attempts,
        no_of_attempt: item.no_of_attempt,
        course_exam: item.course_exam,
        is_completed: item.is_completed,
        is_expired: item.is_expired,
        course_view_count: item.course_view_count,
      }));
      this.serialNoStarting = start;
    },

    disableBackButton() {
      window.history.pushState(null, document.title, window.location.href);

      window.onpopstate = function () {
        window.history.pushState(null, document.title, window.location.href);
      };
    },
    enableBackButton() {
      window.onpopstate = null;
    },
    async Delete_this(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.delete(`course/${id}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
